import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import ResponseItem from "./response-item-list";
import {
  fetchResponseList,
  makeEmptyResponseList,
  searchResponseList,
  fetchProposal,
  fetchAllAttendies,
  fetchUnreviewedproposal,
  fetchReviewedproposal,
  fetchShortlistedproposal,
  fetchRejectedproposal,
  openProposalResponseModal,
  fetchallproposal,
  searchNewResponseList,
  updatedDragProposal,
  filterProposalLoader,
} from "ProposalAction";
import { fetchAllSpeakers } from "ActionsSpeakers";
import { fetchAllExhibitors } from "ActionsExhibitors";
import { fetchAllSponsors } from "ActionsSponsors";
import { fetchUsersCategory } from "DashboardUserAction";
import { fetchTemplate } from "SettingActions";
import { ticketsForSend } from "TicketAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { screenHeightLeftFromTop } from "Constants";
import ChangeReviewer from "./change-reviewer.js";
import ProposalSendTicket from "./proposal-sendticket.js";
import ProposalConfirm from "./proposal-confirm";
import ProposalResponse from "./proposal-response.js";
import DragableProposal from "./dragableproposal";
import Loader from "Loader";
import LocaleStrings from "Languages";

class FormResponse extends Component {
  constructor(props) {
    super(props);
    this.handleSelect = this.handleSelect.bind(this);
    this.state = {
      pageNumber: 1,
      search: "",
      selectedTab: "unreviewed",
      desc: "Please Wait",
      proposalid: "",
      sortby: "none",
      loading: true,
      filter: false,
    };
  }

  componentDidMount() {
    this.props.fetchallproposal(this.props.session, (callback) => {
      this.setState({ loading: false });
    });
    this.props.fetchProposal(this.props.session, (callback) => {});
    this.props.fetchResponseList(this.props.session, "unreviewed");

    this.props.fetchAllSpeakers(this.props.session);
    this.props.fetchAllSponsors(this.props.session);
    this.props.fetchAllExhibitors(this.props.session);
    this.props.fetchAllAttendies(this.props.session);
    this.props.fetchUsersCategory(this.props.session);
    this.props.fetchTemplate(this.props.session);
    let filter = `((eventid=${this.props.session.eventid}) AND (status='enabled'))`;
    this.props.ticketsForSend(this.props.session, filter);
  }

  componentWillReceiveProps(nextState) {
    if (
      this.state.proposalid != "" &&
      this.props.filterbyProposal.filterProposal == true
    ) {
      this.setState({ proposalid: "" });
      this.props.filterProposalLoader(false);
    }
  }

  renderResponseList = () => {
    var { selectedTab } = this.state;
    return _.map(this.props.responseList.data, (response) => {
      return (
        <ResponseItem
          key={response.id}
          response={response}
          selectedTab={selectedTab}
          handleSelect={this.handleSelect}
        />
      );
    });
  };

  renderLoader = () => {
    return (
      <Loader type="line-scale-pulse-out-rapid" active className="loader-div" />
    );
  };

  handleSelect(key) {
    var { proposalid, search, pageNumber } = this.state;

    this.setState({ selectedTab: key });
    this.props.makeEmptyResponseList(
      this.props.session,
      this.props.responseList
    );
    if (search == "") {
      this.props.fetchResponseList(
        this.props.session,
        key,
        proposalid,
        pageNumber,
        0,
        "none"
      );
      this.props.fetchAllAttendies(this.props.session);
    } else {
      this.props.searchResponseList(
        this.props.session,
        key,
        proposalid,
        search,
        pageNumber,
        0,
        (response) => {}
      );
    }
  }

  onSearchUser = (event) => {
    var search = event.target.value;
    var { selectedTab, pageNumber } = this.state;
    if (search == "" && this.state.proposalid == "") {
      this.setState({ loading: true });
      this.setState({ loading: true });
      this.props.fetchallproposal(this.props.session, (response) => {
        this.props.updatedDragProposal(true);
        this.setState({ loading: false });
      });
    } else if (search != "" && this.state.proposalid == "") {
      this.setState({ loading: true });
      this.props.searchNewResponseList(
        this.props.session,
        search,
        "all",
        (callback) => {
          if (callback.success == 1) {
            this.props.updatedDragProposal(true);
            this.setState({ loading: false });
          }
        }
      );
    } else if (search != "" && this.state.proposalid != "") {
      this.setState({ loading: true });
      this.props.searchNewResponseList(
        this.props.session,
        search,
        this.state.proposalid,
        (callback) => {
          if (callback.success == 1) {
            this.props.updatedDragProposal(true);
            this.setState({ loading: false });
          }
        }
      );
    } else if (search == "" && this.state.proposalid != "") {
      this.setState({ loading: true });
      this.props.searchNewResponseList(
        this.props.session,
        "",
        this.state.proposalid,
        (callback) => {
          if (callback.success == 1) {
            this.props.updatedDragProposal(true);
            this.setState({ loading: false });
          }
        }
      );
    }
    this.setState({ search });
  };

  // paginationCallback = (pageNumber) => {
  //   var { selectedTab, proposalid } = this.state;
  //   this.props.fetchResponseList(
  //     this.props.session,
  //     selectedTab,
  //     proposalid,
  //     pageNumber,
  //     0,
  //     "none",
  //     (response) => {}
  //   );
  //   this.setState({ ...this.state, pageNumber });
  // };

  // handleProposal = (event) => {
  //   var proposalid = event.target.value;
  //   console.log('proposalid',proposalid)
  //   this.props.makeEmptyResponseList(
  //     this.props.session,
  //     this.props.responseList
  //   );
  //   var { selectedTab } = this.state;
  //   let pageNumber = 1;
  //   let sortby = "none";
  //   this.setState(
  //     { proposalid, pageNumber, selectedTab, sortby },
  //     this.props.fetchResponseList(
  //       this.props.session,
  //       selectedTab,
  //       proposalid,
  //       pageNumber,
  //       0,
  //       sortby,
  //       (response) => {}
  //     )
  //   );
  // };
  handleProposal = (event) => {
    var proposalid = event.target.value;
    this.setState({ filter: true });

    if (proposalid == "" && this.state.search == "") {
      this.setState({ proposalid: proposalid });
      this.setState({ loading: true });
      this.props.fetchallproposal(this.props.session, (response) => {
        this.props.updatedDragProposal(true);
        this.setState({ filter: false });
        this.setState({ loading: false });
      });
    } else if (proposalid != "" && this.state.search == "") {
      this.setState({ loading: true });
      this.setState({ proposalid: proposalid });
      this.props.searchNewResponseList(
        this.props.session,
        "",
        proposalid,
        (callback) => {
          if (callback.success == 1) {
            this.props.updatedDragProposal(true);
            this.setState({ loading: false });
          }
        }
      );
    } else if (proposalid != "" && this.state.search != "") {
      this.setState({ loading: true });
      this.setState({ proposalid: proposalid });
      this.props.searchNewResponseList(
        this.props.session,
        this.state.search,
        proposalid,
        (callback) => {
          if (callback.success == 1) {
            this.props.updatedDragProposal(true);
            this.setState({ loading: false });
          }
        }
      );
    } else if (proposalid == "" && this.state.search != "") {
      this.setState({ loading: true });
      this.setState({ proposalid: proposalid });
      this.props.searchNewResponseList(
        this.props.session,
        this.state.search,
        "",
        (callback) => {
          if (callback.success == 1) {
            this.props.updatedDragProposal(true);
            this.setState({ loading: false });
          }
        }
      );
    }
  };

  handleSortBy = (event) => {
    var sortby = event.target.value;
    //console.log("sortby", sortby);
    this.props.makeEmptyResponseList(
      this.props.session,
      this.props.responseList
    );
    var { selectedTab } = this.state;
    let pageNumber = 1;
    let proposalid = "";
    this.setState(
      { sortby, pageNumber, selectedTab, proposalid },
      this.props.fetchResponseList(
        this.props.session,
        selectedTab,
        "",
        pageNumber,
        0,
        sortby,
        (response) => {}
      )
    );
  };

  render() {
    var {
      deviceSize,
      responseList,
      showChangeReviewer,
      showProposalResponse,
      showProposalTicketModal,
      proposalList,
      proposalConfirmModal,
      unreviewedproposalList,
      reviewedproposalList,
      shortlistedproposalList,
      rejectedproposalList,
    } = this.props;

    let style = {
      paddingTop: 25,
      paddingLeft: 15,
    };

    let unreviewedCount =
      responseList &&
      responseList.statuscount &&
      responseList.statuscount.unreviewedCount
        ? " (" + responseList.statuscount.unreviewedCount + ")"
        : "(0)";
    let reviewedCount =
      responseList &&
      responseList.statuscount &&
      responseList.statuscount.reviewedCount
        ? " (" + responseList.statuscount.reviewedCount + ")"
        : "(0)";
    let shorlistedCount =
      responseList &&
      responseList.statuscount &&
      responseList.statuscount.shortlistedCount
        ? " (" + responseList.statuscount.shortlistedCount + ")"
        : "(0)";
    let options = [];

    options.push(
      <option
        value=""
        selected={this.state.proposalid === "" ? "selected" : ""}
      >
        {LocaleStrings.proposal_filter}
      </option>
    );
    if (proposalList && proposalList.data && proposalList.data.length > 0) {
      _.map(proposalList.data, (item, index) => {
        let selected =
          this.state.proposalid === item.proposalid ? "selected" : "";

        options.push(
          <option key={index} value={item.proposalid} selected={selected}>
            {item.proposal_name}
          </option>
        );
      });
    }

    let sortoptions = [];

    sortoptions.push(
      <option
        value="none"
        selected={this.state.sortby === "none" ? "selected" : ""}
      >
        {LocaleStrings.proposal_sort}
      </option>
    );
    sortoptions.push(
      <option
        value="all"
        selected={this.state.sortby === "all" ? "selected" : ""}
      >
        All
      </option>
    );
    sortoptions.push(
      <option value="" selected={this.state.sortby === "" ? "selected" : ""}>
        Approved
      </option>
    );
    sortoptions.push(
      <option
        value="reject"
        selected={this.state.sortby === "reject" ? "selected" : ""}
      >
        Rejected
      </option>
    );
    sortoptions.push(
      <option
        value="resubmit"
        selected={this.state.sortby === "resubmit" ? "selected" : ""}
      >
        Resubmission
      </option>
    );
    return (
      <div className="panel noborder-panel">
        {showChangeReviewer.showModal ? <ChangeReviewer /> : ""}
        {showProposalResponse.showModal ? (
          <ProposalResponse handleSelect={this.handleSelect} />
        ) : (
          ""
        )}
        {showProposalTicketModal.showModal ? (
          <ProposalSendTicket handleSelect={this.handleSelect} />
        ) : (
          ""
        )}
        {proposalConfirmModal.showModal ? (
          <ProposalConfirm handleSelect={this.handleSelect} />
        ) : (
          ""
        )}
        <div className="content-header-bar">
          <div className="vertical-align-center">
            <div>
              <div className="tickets-heading">
                {LocaleStrings.response_heading}
              </div>
              <div className="custom-text2-secondary-normal subtext-tabhidden">
                {LocaleStrings.response_subheading}
              </div>
            </div>
          </div>

          <ul className="header-buttons">
            {this.state.selectedTab == "reviewed" ? (
              <li key="sortby">
                <select
                  // className="form-control"
                  // disabled={true}
                  onChange={(e) => this.handleSortBy(e)}
                  className="form-control selectbox dropdown-height-border"
                >
                  {sortoptions}
                </select>
              </li>
            ) : (
              ""
            )}
            <li key="filter">
              <select
                // className="form-control"
                // disabled={this.state.search == "" ? false : true}
                onChange={(e) => this.handleProposal(e)}
                className="form-control selectbox dropdown-height-border"
              >
                {options}
              </select>
            </li>
            <li key="search">
              <input
                className="form-control mapsearch"
                style={{ width: "300px" }}
                placeholder={"Search by Firstname/lastname/email"}
                type="text"
                value={this.state.search}
                onChange={this.onSearchUser}
                // disabled={this.state.filter == false ? false : true}
              />
            </li>
          </ul>
        </div>

        <div
          className="panel-body scrollable-content"
          style={{
            height: deviceSize.height - screenHeightLeftFromTop,
            overflowX: "auto",
          }}
        >
          {this.state.loading == true ? (
            <div className="loader-container">
              <Loader />
              <div className="loader-info">Preparing Abstracts</div>
            </div>
          ) : (
            <>
              <DragableProposal />

              {/* <div
            className="sponsor-table "
            // style={{ marginTop: 60 }}
          >
            <Tabs
              className="branding-tabs mt-0"
              id="speaker-from-tab"
              activeKey={this.state.selectedTab}
              onSelect={this.handleSelect}
            >
              <Tab
                className="pt-15"
                eventKey={"unreviewed"}
                title={
                  LocaleStrings.proposal_for_response_tab_unreviewed +
                  unreviewedCount
                }
              >
                <div>
                  {responseList && responseList.data ? (
                    responseList.data.length > 0 ? (
                      <div className="sponsor-table">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>
                                {
                                  LocaleStrings.proposal_for_response_tab_unreviewed_proposedby
                                }
                              </th>
                              <th>
                                {
                                  LocaleStrings.proposal_for_response_tab_unreviewed_proposal
                                }
                              </th>
                              <th>
                                {
                                  LocaleStrings.proposal_for_response_tab_unreviewed_category
                                }
                              </th>
                              <th>
                                {
                                  LocaleStrings.proposal_for_response_tab_unreviewed_assignedto
                                }
                              </th>
                              <th>
                                {
                                  LocaleStrings.proposal_for_response_tab_unreviewed_action
                                }
                              </th>
                            </tr>
                          </thead>
                          <tbody>{this.renderResponseList()}</tbody>
                        </table>
                        {responseList && responseList.count > itemCount ? (
                          <Pagination
                            activePage={this.state.pageNumber}
                            itemsCountPerPage={itemCount}
                            totalItemsCount={responseList.count}
                            pageRangeDisplayed={10}
                            onChange={this.paginationCallback}
                            style={{ float: "right" }}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    ) : this.state.search != "" ? (
                      <div className="no-content-container">
                        <div className="no-content-message">
                          {LocaleStrings.proposal_text_no_unreviewed_found}
                        </div>
                      </div>
                    ) : (
                      <div className="no-content-container">
                        <div className="no-content-message">
                          {LocaleStrings.proposal_text_no_unreviewed_found}
                        </div>
                      </div>
                    )
                  ) : (
                    <div className="loader-container">
                      {this.renderLoader()}
                      <div className="loader-info">{this.state.desc}</div>
                    </div>
                  )}
                </div>
              </Tab>
              <Tab
                className="pt-15"
                eventKey={"reviewed"}
                title={
                  LocaleStrings.proposal_for_response_tab_reviewed +
                  reviewedCount
                }
              >
                <div>
                  {responseList && responseList.data ? (
                    responseList.data.length > 0 ? (
                      <div className="sponsor-table">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>
                                {
                                  LocaleStrings.proposal_for_response_tab_reviewed_proposedby
                                }
                              </th>
                              <th>
                                {
                                  LocaleStrings.proposal_for_response_tab_reviewed_proposal
                                }
                              </th>
                              <th>
                                {
                                  LocaleStrings.proposal_for_response_tab_reviewed_points
                                }
                              </th>
                              <th>
                                {
                                  LocaleStrings.proposal_for_response_tab_reviewed_rankedby
                                }
                              </th>
                              <th>{LocaleStrings.proposal_reviewer_action}</th>
                            </tr>
                          </thead>
                          <tbody>{this.renderResponseList()}</tbody>
                        </table>
                        {responseList && responseList.count > itemCount ? (
                          <Pagination
                            activePage={this.state.pageNumber}
                            itemsCountPerPage={itemCount}
                            totalItemsCount={responseList.count}
                            pageRangeDisplayed={10}
                            onChange={this.paginationCallback}
                            style={{ float: "right" }}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    ) : this.state.search != "" ? (
                      <div className="no-content-container">
                        <div className="no-content-message">
                          {LocaleStrings.proposal_text_no_reviewed_found}
                        </div>
                      </div>
                    ) : (
                      <div className="no-content-container">
                        <div className="no-content-message">
                          {LocaleStrings.proposal_text_no_reviewed_found}
                        </div>
                      </div>
                    )
                  ) : (
                    <div className="loader-container">
                      {this.renderLoader()}
                      <div className="loader-info">{this.state.desc}</div>
                    </div>
                  )}
                </div>
              </Tab>
              <Tab
                className="pt-15"
                eventKey={"shortlisted"}
                title={
                  LocaleStrings.proposal_for_response_tab_shorlisted +
                  shorlistedCount
                }
              >
                <div>
                  {responseList && responseList.data ? (
                    responseList.data.length > 0 ? (
                      <div className="sponsor-table">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>
                                {
                                  LocaleStrings.proposal_for_response_tab_shorlisted_proposedby
                                }
                              </th>
                              <th>
                                {
                                  LocaleStrings.proposal_for_response_tab_shorlisted_proposal
                                }
                              </th>
                              <th>
                                {
                                  LocaleStrings.proposal_for_response_tab_shorlisted_points
                                }
                              </th>
                              <th>
                                {
                                  LocaleStrings.proposal_for_response_tab_shorlisted_rankedby
                                }
                              </th>
                              <th>{LocaleStrings.proposal_reviewer_action}</th>
                            </tr>
                          </thead>
                          <tbody>{this.renderResponseList()}</tbody>
                        </table>
                        {responseList && responseList.count > itemCount ? (
                          <Pagination
                            activePage={this.state.pageNumber}
                            itemsCountPerPage={itemCount}
                            totalItemsCount={responseList.count}
                            pageRangeDisplayed={10}
                            onChange={this.paginationCallback}
                            style={{ float: "right" }}
                          />
                        ) : (
                          ""
                        )}
                      </div>
                    ) : this.state.search != "" ? (
                      <div className="no-content-container">
                        <div className="no-content-message">
                          {LocaleStrings.proposal_text_no_shorlisted_found}
                        </div>
                      </div>
                    ) : (
                      <div className="no-content-container">
                        <div className="no-content-message">
                          {LocaleStrings.proposal_text_no_shorlisted_found}
                        </div>
                      </div>
                    )
                  ) : (
                    <div className="loader-container">
                      {this.renderLoader()}
                      <div className="loader-info">{this.state.desc}</div>
                    </div>
                  )}
                </div>
              </Tab>
            </Tabs>
          </div> */}
            </>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    deviceSize: state.deviceSize,
    session: state.session,
    responseList: state.responseList,
    showChangeReviewer: state.showChangeReviewer,
    showProposalResponse: state.showProposalResponse,
    showProposalTicketModal: state.showProposalTicketModal,
    proposalList: state.proposalList,
    proposalConfirmModal: state.proposalConfirmModal,
    unreviewedproposalList: state.unreviewedproposalList,
    reviewedproposalList: state.reviewedproposalList,
    shortlistedproposalList: state.shortlistedproposalList,
    rejectedproposalList: state.rejectedproposalList,
    showproposalLoader: state.showproposalLoader,
    allresponseProposal: state.allresponseProposal,
    filterbyProposal: state.filterbyProposal,
  };
}

export default connect(mapStateToProps, {
  fetchResponseList,
  fetchAllSpeakers,
  fetchUsersCategory,
  fetchTemplate,
  ticketsForSend,
  makeEmptyResponseList,
  searchResponseList,
  fetchProposal,
  fetchAllExhibitors,
  fetchAllSponsors,
  fetchAllAttendies,
  fetchUnreviewedproposal,
  fetchReviewedproposal,
  fetchShortlistedproposal,
  fetchRejectedproposal,
  showError,
  showSuccess,
  openProposalResponseModal,
  fetchallproposal,
  searchNewResponseList,
  updatedDragProposal,
  filterProposalLoader,
})(FormResponse);
